import logo from './logo.svg';
import './App.css';
import './App.scss'
// import Home from './Pages/Home';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';



import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// import Navbar from './Components/Navbar';
// import Footer from './Components/Footer';
import AllRoutes from './Components/AllRoutes';
// import Home from './Pages/Home';
// import Menpage from './Pages/Menpage';





function App() {
  return (
    <div >
    
    <AllRoutes/>
 

    </div>
  );
}

export default App;
